@if (config$ | async; as config) {
  <app-advanced-reports
    [config]="config"
    [rowData]="rowData$ | async"
    [tabs]="tabs$ | async"
    [getTabExportData]="getTabExportData"
  ></app-advanced-reports>
}
